/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
    ADD_TENANTS(state, item) {
        state.tenants.unshift(item)
    },
    UPDATE_TENANTS(state, item) {
        const index = state.tenants.findIndex((e) => e.tenantsId === item.tenantsId)
        Object.assign(state.tenants[index], item)
    },

    REMOVE_TENANTS(state, tenantsId) {
        const leaveIndex = state.tenants.findIndex((e) => e.tenantsId == tenantsId);
        state.tenants.splice(leaveIndex, 1);
    },
    GET_ALL_TENANTS(state, payload) {
        state.tenants = payload
        //console.log("tenants")
        //console.log(state.tenants)
    },
    GET_ALL_SETTINGS(state, settings){
        state.tenantsSettings = settings
    },
    GET_ALL_SIGNATORIES(state, signatories) {
        state.signatories = signatories
    },
    
    GET_ALL_TENANTSSCHEDULE(state, schedule) {
        state.tenantsSchedule = schedule
    },

    UPLOAD_PHOTO(state, photo){
        state.photoUpload.unshift(photo)
    },
    GET_ALL_APPROVERS(state, approvers){
        state.approvers = approvers
    }

}